import React, { Component } from 'react';
import withAuth from './../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import './css/homepage.css';
import Welcome from '../Components/Homepage/Welcome';
import MasterLanding from '../Components/Master/MasterLanding';

class MasterContainer extends Component {
    render() {
        return (
            <div>
                <Navbar history={this.props.history} />
                <div className="main-body">

                   <MasterLanding />

                </div>
            </div>
        )
    }
}

export default withAuth(MasterContainer);